import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UnescapeHtmlPipe } from './unescape-html.pipe';

@NgModule({
  declarations: [UnescapeHtmlPipe],
  imports: [CommonModule],
  exports: [UnescapeHtmlPipe],
})
export class UnescapeHtmlPipeModule {}
